module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05introduction#int"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/05introduction#int"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06part01#ch1"
    }
  }, [_vm._v("Chapter 1: BIRTHDAYS")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/06part01#ch1"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/19part02#ch2"
    }
  }, [_vm._v("Chapter 2: THE ZODIAC")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/19part02#ch2"
    }
  }, [_vm._v("137")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/46part03#ch3"
    }
  }, [_vm._v("Chapter 3: NAMES")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/46part03#ch3"
    }
  }, [_vm._v("179")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/53part04#ch4"
    }
  }, [_vm._v("Chapter 4: DREAMS")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/53part04#ch4"
    }
  }, [_vm._v("223")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/79part05#ch5"
    }
  }, [_vm._v("Chapter 5: COLOR")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/79part05#ch5"
    }
  }, [_vm._v("291")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/89part06#ch6"
    }
  }, [_vm._v("Chapter 6: LOVE AND FRIENDSHIP")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/89part06#ch6"
    }
  }, [_vm._v("337")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fad51b1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04-contents.vue
// module id = 66
// module chunks = 0